(function () {
  var scrollClass = 'nfp-scrolled';
  var threshold = 24;
  var ticking = false;

  function updateHeaderState() {
    if (window.scrollY > threshold) {
      document.body.classList.add(scrollClass);
    } else {
      document.body.classList.remove(scrollClass);
    }

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderState);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('load', updateHeaderState);
  document.addEventListener('shopify:section:load', updateHeaderState);
})();